export const CRYPTANIUM_VAULT_STRINGS = {
  HEADER: {
    TITLE: "Cryptanium Vault",
    STATS: {
      TVL: "Vault TVL",
      APY: "Projected APR",
    },
  },
  SECTIONS: {
    DEPOSIT_WITHDRAW: {
      TABS: [{ key: "deposit", title: "Deposit" }],
      DISCLAIMER: {
        DEPOSIT: "",
        WITHDRAW: "",
      },
    },
    PORTFOLIO: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "apr_reports", title: "Strategy Reports", isNew: true },
        { key: "holdings", title: "My Holdings" },
      ],
      HOLDINGS: {
        walletConnect: "Connect your wallet to view your holdings",
        nexusMutual: {
          title:
            "Insure your xgUSD with Nexus Mutual. 10% discount for Gain users.",
          CTA: "Get insurance",
          imgSrc: "/assets/vaults/nexus.svg",
        },
      },
      POINTS: {
        walletConnect: "Connect wallet to view your points",
        supported: [],
      },
      CLAIMS: {
        walletConnect: "Connect wallet to view your claims",
        noData: "No claims data available",
        COLUMNS: ["Asset", "Amount", "Status"],
      },
      HISTORY: {
        walletConnect: "Connect wallet to view your history",
        COLUMNS: ["Date", "Time", "Transaction", "Asset", "Amount", "Status"],
      },
      APR_REPORTS: {
        walletConnect: "Connect wallet to view your history",
        cmsKey: "cryptanium_vault",
        COLUMNS: [
          {
            name: "Strategy",
            key: "strategy_name",
            hasImage: true,
          },
          {
            name: "Allocation",
            isNumeric: true,
            key: "allocation",
          },
          {
            name: "APR on strategy",
            isNumeric: true,
            key: "apr",
            tooltipText:
              "APR offered by the selected strategy, based on its current performance.",
          },
          {
            name: "Realized APR",
            isNumeric: true,
            key: "realized_apr",
            tooltipText:
              "The portion of APR that has been finalised. It reflects returns that are no longer subject to change.",
          },
          {
            name: "Accruing APR",
            isNumeric: true,
            key: "accruing_apr",
            tooltipText:
              "The portion of APR that is currently accruing and will be finalised over time, based on ongoing performance.",
          },
          {
            name: "APR on allocation",
            isNumeric: true,
            key: "apr_on_allocation",
            tooltipText:
              "Effective APR based on the strategy's rate and the proportion of assets allocated to it.",
          },
        ],
      },
    },
    OVERVIEW: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "strategies", title: "Strategies" },
      ],
      DATA: {
        MAIN: {
          heading: "Unlock cryptanium returns with DeFi",
          headingIcon: "/assets/vaults/agETHOverview.png",
          desc: "Deposit USDT to earn enhanced rewards through curated DeFi strategies. In return, you receive xgUSD, which can be used across DeFi while continuing to accrue rewards.",
          disclaimerLink:
            "https://docs.google.com/document/d/1KnAvqWDWXr-GpU3c1g_CtQU6y1fpxX9oaGRcrx4lcWQ",
        },
        FEES: {
          heading: "Fees & Details",
          data: [
            {
              key: "platform",
              title: "Platform fee",
              value: "1.5%",
              tooltip: "Annual fee charged for managing the vault",
            },
            {
              key: "performance",
              title: "Performance fee",
              value: "20%",
              tooltip: "Annual fee charged on rewards generated by the vault",
            },
            {
              key: "redemption",
              title: "Redemption period",
              value: "3 days",
            },
          ],
        },
        PARTNERS: {
          heading: "Vault Partners",
          details: [
            {
              key: "ultrayield",
              imgSrc: "/assets/vaults/ultrayield.svg",
              link: "",
              imageWidth: 70,
            },
          ],
        },
      },
      STRATEGIES: {
        COLUMNS: [
          {
            label: "Strategy",
            accessor: "strategy",
          },
          {
            label: "Allocation %",
            accessor: "allocation",
          },
        ],
      },
      RESERVES: {
        COLUMNS: ["Date", "Time", "Block", "Asset", "Amount", "Txn"],
      },
    },
  },
};
